import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { get } from '@nrspl/js-api-client';
import { CUSTOMIZATION_JSON_URL } from 'appconstants';
import logo from 'assets/img/neurosoft-logo.svg';
import { CustomizationContext } from './customizationContext';

const defaultState = {
  logo: {
    url: logo,
  },
};

const CustomizationProvider = ({ children }) => {
  const [state, setState] = useState(defaultState);

  const loadCustomizationJSON = useCallback(async () => {
    try {
      const customization = await get(CUSTOMIZATION_JSON_URL);
      setState(customization);
    } catch (error) {
      console.log('Failed to load customization JSON\n', error); // eslint-disable-line no-console
    }
  }, []);

  useEffect(() => {
    loadCustomizationJSON();
  }, [loadCustomizationJSON]);

  return <CustomizationContext.Provider value={state}>{children}</CustomizationContext.Provider>;
};

CustomizationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CustomizationProvider;
